import getApiToken from './getApiToken';

export const processedData = (data) => {
  // console.log('processedData', data);
  let extras = [];
  if (data.extras) {
    extras = data.extras.map(extra => {
      const shortTitle = extra.name.includes('Complete') ? 'Complete Package' : extra.name;
      return {
        ...extra,
        wbstlTagImage: extra.image && extra.image.mediaItemUrl,
        wbstlTagTitle: extra.name,
        wbstlTagPrice: extra.price,
        wbstlTagDescription: '',
        summaryLabel: shortTitle,
        slug: extra.name.toLowerCase().replace(/ /g, '_')
      };
    });
  }
  const ageGroups = data.wbstlTicketAgeGroups;
  const tickets = ticketsContent(ageGroups, extras);
  // var fares = faresContent(ageGroups, extras);

  return {
    sectionTitle: data.title,
    sectionIntro: data.buyTicketsIntro,
    sectionTooltip: data.buyTicketsTooltip,
    tix: tickets,
    rows: ageGroups.length
  }
}
export const ticketsContent = (data, extras) => {
  // console.log('tickets data', data);
  const iq = iqContent(extras);
  const tq = data.map(item => {
    let slug = item.wbstlTagTitle.toLowerCase().replace(/\s/g, '_');
    slug = slug.includes('family') && slug.includes('2') ? 'family_2_2' : slug.includes('family') && slug.includes('3') ? 'family_1_3' : slug;
    slug = slug.includes('4') ? 'child_0_4' : slug;
    const obj = {
      ...item,
      slug: slug,
      price: item.wbstlTagPrice === 'Free' ? '0' : item.wbstlTagPrice.substring(1)
    }
    obj['qty'] = slug.includes('adult') ? 1 : 0;
    return obj;
  });
  return tq.concat(iq);
}

const iqContent = (data) => {
  // console.log('iqContent data', data);
  let slugs = {
    'christmas_souvenir_gift_box': 'christmas_souvenir_gift_box',
    'souvenir_gift_box': 'souvenir_gift_box',
    'souvenir_gift_wallet': 'souvenir_gift_wallet',
    'complete_studio_tour_package': 'package',
    'souvenir_guidebook': 'guidebook',
    'digital_guide': 'digital_guidebook',
    'group_digital_guide': 'group_guidebook',
    'priority_parking': 'parking',
    'butterbeer_tankard': 'butterbeer'
  };
  return data.map(item => {
    return {
      ...item,
      id: slugs[item.slug],
      slug: slugs[item.slug],
      qty: 0,
      price: item.wbstlTagPrice.substring(1),
      summaryLabel: item.wbstlTagTitle
    }
  });
}

export const faresContent = (data, extras) => {
  // console.log('fares data', data);
  const iq = iqContent(extras);
  // console.log('iq', iq);
  let priceArr = [];
  data.forEach(d => {
    const id = d.wbstlTagTitle.toLowerCase().replace(/ /g, '_');
    if (d.wbstlTagTitle.includes('4 Years')) {
      priceArr.push({ id: "child_0_4", price: "0", summaryLabel: d.wbstlTagTitle });
    } else if (d.wbstlTagTitle.includes('Family')) {
      priceArr.push({ id: 'family_2_2', price: '150.00', summaryLabel: "Family - 2 Adult, 2 Child" });
      priceArr.push({ id: 'family_1_3', price: '150.00', summaryLabel: "Family - 1 Adult, 3 Child" });
    } else {
      priceArr.push({
        id: id,
        price: d.wbstlTagPrice === 'Free' ? '0' : d.wbstlTagPrice.substring(1),
        summaryLabel: d.wbstlTagTitle
      });
    }
  });
  return priceArr.concat(iq);
}

export const addonsContent = (data) => {
  console.log('addons data', data);
}

const apiToken = getApiToken();
export const formatPostArgs = (newState) => {
  if (newState) {
    var cS = JSON.stringify(newState);
    var obj = {
      '_t': apiToken,
      'state': cS
    };
    cS = encodeURI(cS);
    var params = ["_t=", apiToken, "&state=", cS];
    params = params.join('');
  } else {
    var obj = { '_t': apiToken };
    var params = ["_t=", apiToken];
    params = params.join('');
  }
  // var data_format = location.hostname.includes('wbstudiotour') ? params : obj;
  return obj;
}

export const serialize = (obj) => {
  let str = "";
  for (let key in obj) {
    if (str != "") {
      str += "&";
    }
    str += key + "=" + encodeURIComponent(obj[key]);
  }
  return str;
}
